import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import styled from 'styled-components';
import { Field } from '../field';
export var CustomField = styled(Field)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: none;\n  background: transparent;\n  padding: 0;\n  flex-direction: ", ";\n  gap: ", ";\n  align-items: start;\n  margin: ", ";\n  "])), function (_ref) {
  var direction = _ref.direction;
  return direction !== null && direction !== void 0 ? direction : 'column';
}, function (_ref2) {
  var direction = _ref2.direction;
  return direction === 'row' ? '48px' : '0';
}, function (_ref3) {
  var direction = _ref3.direction;
  return direction === 'row' ? '0 32px 0 0' : '0 0 32px 0';
});
export var RadioButtonComponent = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  margin: 10px 0;\n  padding-left: 20px;\n  "])));
export var CustomInput = styled.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  top: 0;\n\tleft: 0;\n\tposition: absolute;\n  \n  opacity: 0;\n  cursor: ", "; \n  z-index: 1;\n  margin: 0;\n  padding: 0;\n  height: ", ";\n  width: ", " ;\n\n  &:not(:disabled){\n    &:focus ~ span, &:active ~ span{\n      border: 2px solid ", ";\n      background: transparent;\n    }\n\n    &:checked ~ span {\n      background-color: transparent;\n      border: 6px solid ", ";\n    }\n\n    &:checked ~ span:after {\n      display: block;\n    }\n  }\n\n  &:disabled {\n    & ~ span{\n    border: 2px solid ", ";\n    }\n  }\n  "])), function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref5) {
  var fieldOptions = _ref5.fieldOptions;
  return fieldOptions === 'small' ? '16px' : '20px';
}, function (_ref6) {
  var fieldOptions = _ref6.fieldOptions;
  return fieldOptions === 'small' ? '16px' : '20px';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.secondary.lighten;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.secondary.lighten;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.grey24;
});
export var OptionLabel = styled.label(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-left: ", ";\n  font-size: ", ";\n  color: ", ";\n  line-height: 20px;\n  cursor: pointer;\n  "])), function (_ref10) {
  var fieldOptions = _ref10.fieldOptions;
  return fieldOptions === 'small' ? '16px' : '12px';
}, function (_ref11) {
  var fieldOptions = _ref11.fieldOptions;
  return fieldOptions === 'small' ? '14px' : '16px';
}, function (_ref12) {
  var disabled = _ref12.disabled,
      theme = _ref12.theme;
  return disabled ? theme.colors.grey24 : theme.colors.grey84;
});
export var Checkmark = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: ", ";\n  width: ", ";\n  border-radius: 50%;\n  border: 2px solid #ccc;\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: ", ";\n\t  height: ", ";\n    border-radius: 50%;\n    background: white;\n  }"])), function (_ref13) {
  var fieldOptions = _ref13.fieldOptions;
  return fieldOptions === 'small' ? '16px' : '20px';
}, function (_ref14) {
  var fieldOptions = _ref14.fieldOptions;
  return fieldOptions === 'small' ? '16px' : '20px';
}, function (_ref15) {
  var fieldOptions = _ref15.fieldOptions;
  return fieldOptions === 'small' ? '6px' : '8px';
}, function (_ref16) {
  var fieldOptions = _ref16.fieldOptions;
  return fieldOptions === 'small' ? '6px' : '8px';
});